// this file was prevaled
// This file needs to be a JavaScript file using CommonJS to be compatiable with preval
module.exports = {
  "theme": {
    "borderWidths": [0, "1px"],
    "breakpoints": ["544px", "768px", "1012px", "1280px"],
    "colors": {
      "bodytext": "#24292e",
      "black": "#1b1f23",
      "white": "#ffffff",
      "gray": ["#fafbfc", "#f6f8fa", "#e1e4e8", "#d1d5da", "#959da5", "#6a737d", "#586069", "#444d56", "#2f363d", "#24292e"],
      "blue": ["#f1f8ff", "#dbedff", "#c8e1ff", "#79b8ff", "#2188ff", "#0366d6", "#005cc5", "#044289", "#032f62", "#05264c"],
      "green": ["#f0fff4", "#dcffe4", "#bef5cb", "#85e89d", "#34d058", "#28a745", "#22863a", "#176f2c", "#165c26", "#144620"],
      "orange": ["#fff8f2", "#ffebda", "#ffd1ac", "#ffab70", "#fb8532", "#f66a0a", "#e36209", "#d15704", "#c24e00", "#a04100"],
      "purple": ["#f5f0ff", "#e6dcfd", "#d1bcf9", "#b392f0", "#8a63d2", "#6f42c1", "#5a32a3", "#4c2889", "#3a1d6e", "#29134e"],
      "red": ["#ffeef0", "#ffdce0", "#fdaeb7", "#f97583", "#ea4a5a", "#d73a49", "#cb2431", "#b31d28", "#9e1c23", "#86181d"],
      "yellow": ["#fffdef", "#fffbdd", "#fff5b1", "#ffea7f", "#ffdf5d", "#ffd33d", "#f9c513", "#dbab09", "#b08800", "#735c0f"],
      "pink": ["#ffeef8", "#fedbf0", "#f9b3dd", "#f692ce", "#ec6cb9", "#ea4aaa", "#d03592", "#b93a86", "#99306f", "#6d224f"],
      "blackfade15": "rgba(27, 31, 35, 0.15)",
      "blackfade20": "rgba(27, 31, 35, 0.20)",
      "blackfade30": "rgba(27,31,35,0.3)",
      "blackfade35": "rgba(27, 31, 35, 0.35)",
      "blackfade50": "rgba(27, 31, 35, 0.5)",
      "whitefade15": "rgba(255, 255, 255, 0.15)",
      "whitefade50": "rgba(255, 255, 255, 0.50)",
      "whitefade70": "rgba(255, 255, 255, 0.70)",
      "state": {
        "error": "#d73a49",
        "failure": "#d73a49",
        "pending": "#dbab09",
        "queued": "#dbab09",
        "success": "#28a745",
        "unknown": "#959da5",
        "hover": {
          "primaryBg": "#0366d6",
          "primaryBorder": "#0366d6",
          "primaryText": "#ffffff",
          "primaryIcon": "#ffffff",
          "secondaryBg": "#f6f8fa",
          "secondaryBorder": "#f6f8fa"
        },
        "selected": {
          "primaryBg": "#0366d6",
          "primaryBorder": "#0366d6",
          "primaryText": "#ffffff",
          "primaryIcon": "#ffffff"
        },
        "focus": {
          "border": "#0366d6"
        }
      },
      "border": {
        "blackFade": "rgba(27,31,35,0.15)",
        "blue": "#0366d6",
        "blueLight": "#c8e1ff",
        "grayLight": "#eaecef",
        "gray": "#e1e4e8",
        "grayDark": "#d1d5da",
        "grayDarker": "#444d56",
        "green": "#34d058",
        "greenLight": "#a2cbac",
        "purple": "#6f42c1",
        "red": "#d73a49",
        "redLight": "#cea0a5",
        "white": "#ffffff",
        "whiteFade": "rgba(255,255,255,0.15)",
        "yellow": "#d9d0a5",
        "primary": "#e1e4e8",
        "secondary": "#eaecef",
        "tertiary": "#d1d5da",
        "overlay": "#e1e4e8",
        "inverse": "#ffffff",
        "info": "#0366d6",
        "danger": "#d73a49",
        "success": "#34d058",
        "warning": "#f9c513"
      },
      "counter": {
        "bg": "rgba(209,213,218,0.5)",
        "text": "#24292e",
        "primary": {
          "text": "#ffffff",
          "bg": "#6a737d"
        },
        "secondary": {
          "text": "#6a737d"
        }
      },
      "filterList": {
        "hoverBg": "#eaecef"
      },
      "text": {
        "white": "#ffffff",
        "gray": "#586069",
        "grayLight": "#6a737d",
        "grayDark": "#24292e",
        "red": "#cb2431",
        "primary": "#24292e",
        "secondary": "#586069",
        "tertiary": "#6a737d",
        "placeholder": "#6a737d",
        "disabled": "#959da5",
        "inverse": "#ffffff",
        "link": "#0366d6",
        "danger": "#cb2431",
        "success": "#22863a",
        "warning": "#b08800"
      },
      "bg": {
        "gray": "#f6f8fa",
        "grayLight": "#fafbfc",
        "grayDark": "#24292e",
        "disabled": "#F3F4F6",
        "canvas": "#ffffff",
        "canvasMobile": "#ffffff",
        "canvasInverse": "#24292e",
        "canvasInset": "#f6f8fa",
        "primary": "#ffffff",
        "secondary": "#fafbfc",
        "tertiary": "#f6f8fa",
        "overlay": "#ffffff",
        "backdrop": "rgba(27,31,35,0.5)",
        "info": "#f1f8ff",
        "infoInverse": "#0366d6",
        "danger": "#ffeef0",
        "dangerInverse": "#d73a49",
        "success": "#dcffe4",
        "successInverse": "#28a745",
        "warning": "#fff5b1",
        "warningInverse": "#ffd33d"
      },
      "accent": "#f66a0a",
      "labels": {
        "gray": "#e1e4e8",
        "grayText": "#24292e",
        "grayDark": "#6a737d",
        "grayDarkText": "#24292e",
        "blue": "#0366d6",
        "blueText": "#0366d6",
        "orange": "#f66a0a",
        "orangeText": "#e36209",
        "green": "#28a745",
        "greenText": "#22863a",
        "red": "#cb2431",
        "redText": "#cb2431",
        "yellow": "#f9c513",
        "yellowText": "#735c0f",
        "pink": "#ec6cb9",
        "pinkText": "#d03592",
        "purple": "#8a63d2",
        "purpleText": "#6f42c1"
      },
      "auto": {
        "black": "#1b1f23",
        "white": "#ffffff",
        "gray": ["#fafbfc", "#f6f8fa", "#e1e4e8", "#d1d5da", "#959da5", "#6a737d", "#586069", "#444d56", "#2f363d", "#24292e"],
        "blue": ["#f1f8ff", "#dbedff", "#c8e1ff", "#79b8ff", "#2188ff", "#0366d6", "#005cc5", "#044289", "#032f62", "#05264c"],
        "green": ["#f0fff4", "#dcffe4", "#bef5cb", "#85e89d", "#34d058", "#28a745", "#22863a", "#176f2c", "#165c26", "#144620"],
        "yellow": ["#fffdef", "#fffbdd", "#fff5b1", "#ffea7f", "#ffdf5d", "#ffd33d", "#f9c513", "#dbab09", "#b08800", "#735c0f"],
        "orange": ["#fff8f2", "#ffebda", "#ffd1ac", "#ffab70", "#fb8532", "#f66a0a", "#e36209", "#d15704", "#c24e00", "#a04100"],
        "red": ["#ffeef0", "#ffdce0", "#fdaeb7", "#f97583", "#ea4a5a", "#d73a49", "#cb2431", "#b31d28", "#9e1c23", "#86181d"],
        "purple": ["#f5f0ff", "#e6dcfd", "#d1bcf9", "#b392f0", "#8a63d2", "#6f42c1", "#5a32a3", "#4c2889", "#3a1d6e", "#29134e"],
        "pink": ["#ffeef8", "#fedbf0", "#f9b3dd", "#f692ce", "#ec6cb9", "#ea4aaa", "#d03592", "#b93a86", "#99306f", "#6d224f"]
      },
      "icon": {
        "primary": "#24292e",
        "secondary": "#586069",
        "tertiary": "#959da5",
        "info": "#0366d6",
        "danger": "#d73a49",
        "success": "#22863a",
        "warning": "#b08800"
      },
      "fade": {
        "fg10": "rgba(27,31,35,0.1)",
        "fg15": "rgba(27,31,35,0.15)",
        "fg30": "rgba(27,31,35,0.3)",
        "fg50": "rgba(27,31,35,0.5)",
        "fg70": "rgba(27,31,35,0.7)",
        "fg85": "rgba(27,31,35,0.85)",
        "black10": "rgba(27,31,35,0.1)",
        "black15": "rgba(27,31,35,0.15)",
        "black30": "rgba(27,31,35,0.3)",
        "black50": "rgba(27,31,35,0.5)",
        "black70": "rgba(27,31,35,0.7)",
        "black85": "rgba(27,31,35,0.85)",
        "white10": "rgba(255,255,255,0.1)",
        "white15": "rgba(255,255,255,0.15)",
        "white30": "rgba(255,255,255,0.3)",
        "white50": "rgba(255,255,255,0.5)",
        "white70": "rgba(255,255,255,0.7)",
        "white85": "rgba(255,255,255,0.85)"
      },
      "alert": {
        "info": {
          "text": "#24292e",
          "icon": "rgba(4,66,137,0.6)",
          "bg": "#dbedff",
          "border": "rgba(4,66,137,0.2)"
        },
        "warn": {
          "text": "#24292e",
          "icon": "#b08800",
          "bg": "#fffbdd",
          "border": "rgba(176,136,0,0.2)"
        },
        "error": {
          "text": "#24292e",
          "icon": "rgba(158,28,35,0.6)",
          "bg": "#ffe3e6",
          "border": "rgba(158,28,35,0.2)"
        },
        "success": {
          "text": "#24292e",
          "icon": "rgba(23,111,44,0.8)",
          "bg": "#dcffe4",
          "border": "rgba(23,111,44,0.2)"
        }
      },
      "autocomplete": {
        "rowBorder": "#eaecef"
      },
      "blankslate": {
        "icon": "#a3aab1"
      },
      "btn": {
        "text": "#24292e",
        "bg": "#fafbfc",
        "border": "rgba(27,31,35,0.15)",
        "hoverBg": "#f3f4f6",
        "hoverBorder": "rgba(27,31,35,0.15)",
        "selectedBg": "#edeff2",
        "focusBg": "#fafbfc",
        "focusBorder": "rgba(27,31,35,0.15)",
        "primary": {
          "text": "#ffffff",
          "bg": "#2ea44f",
          "border": "rgba(27,31,35,0.15)",
          "hoverBg": "#2c974b",
          "hoverBorder": "rgba(27,31,35,0.15)",
          "selectedBg": "#2a8f47",
          "disabledText": "rgba(255,255,255,0.8)",
          "disabledBg": "#94d3a2",
          "disabledBorder": "rgba(27,31,35,0.1)",
          "focusBg": "#2ea44f",
          "focusBorder": "rgba(27,31,35,0.15)",
          "icon": "rgba(255,255,255,0.8)",
          "counterBg": "rgba(255,255,255,0.2)"
        },
        "outline": {
          "text": "#0366d6",
          "hoverText": "#ffffff",
          "hoverBg": "#0366d6",
          "hoverBorder": "rgba(27,31,35,0.15)",
          "hoverCounterBg": "rgba(255,255,255,0.2)",
          "selectedText": "#ffffff",
          "selectedBg": "#035fc7",
          "selectedBorder": "rgba(27,31,35,0.15)",
          "disabledText": "rgba(3,102,214,0.5)",
          "disabledBg": "#fafbfc",
          "disabledCounterBg": "rgba(3,102,214,0.05)",
          "focusBorder": "rgba(27,31,35,0.15)",
          "counterBg": "rgba(3,102,214,0.1)"
        },
        "danger": {
          "text": "#d73a49",
          "hoverText": "#ffffff",
          "hoverBg": "#cb2431",
          "hoverBorder": "rgba(27,31,35,0.15)",
          "hoverCounterBg": "rgba(255,255,255,0.2)",
          "selectedText": "#ffffff",
          "selectedBg": "#d42d3d",
          "selectedBorder": "rgba(27,31,35,0.15)",
          "disabledText": "rgba(215,58,73,0.5)",
          "disabledBg": "#fafbfc",
          "disabledCounterBg": "rgba(215,58,73,0.05)",
          "focusBorder": "rgba(27,31,35,0.15)",
          "counterBg": "rgba(215,58,73,0.1)",
          "icon": "#d73a49",
          "hoverIcon": "#ffffff"
        },
        "counterBg": "rgba(27,31,35,0.08)"
      },
      "label": {
        "border": "#e1e4e8",
        "primary": {
          "text": "#24292e",
          "border": "#6a737d"
        },
        "secondary": {
          "text": "#586069",
          "border": "#e1e4e8"
        },
        "info": {
          "text": "#0366d6",
          "border": "#0366d6"
        },
        "success": {
          "text": "#22863a",
          "border": "#28a745"
        },
        "warning": {
          "text": "#735c0f",
          "border": "#b08800"
        },
        "danger": {
          "text": "#d73a49",
          "border": "#cb2431"
        },
        "orange": {
          "text": "#c24e00",
          "border": "#f66a0a"
        }
      },
      "input": {
        "bg": "#ffffff",
        "contrastBg": "#fafbfc",
        "border": "#e1e4e8",
        "disabledBg": "#ffffff",
        "disabledBorder": "#e1e4e8",
        "warningBorder": "#f9c513",
        "errorBorder": "#cb2431",
        "tooltip": {
          "success": {
            "text": "#144620",
            "bg": "#dcffe4",
            "border": "#34d058"
          },
          "warning": {
            "text": "#735c0f",
            "bg": "#fff5b1",
            "border": "#f9c513"
          },
          "error": {
            "text": "#86181d",
            "bg": "#ffeef0",
            "border": "#f97583"
          }
        }
      },
      "avatar": {
        "bg": "#ffffff",
        "border": "rgba(0,0,0,0)",
        "stackFade": "#d1d5da",
        "stackFadeMore": "#e1e4e8"
      },
      "toast": {
        "text": "#24292e",
        "bg": "#ffffff",
        "border": "#e1e4e8",
        "icon": "#ffffff",
        "iconBg": "#0366d6",
        "iconBorder": "rgba(0,0,0,0)",
        "success": {
          "text": "#24292e",
          "border": "#e1e4e8",
          "icon": "#ffffff",
          "iconBg": "#28a745",
          "iconBorder": "rgba(0,0,0,0)"
        },
        "warning": {
          "text": "#24292e",
          "border": "#e1e4e8",
          "icon": "#24292e",
          "iconBg": "#ffd33d",
          "iconBorder": "rgba(0,0,0,0)"
        },
        "danger": {
          "text": "#24292e",
          "border": "#e1e4e8",
          "icon": "#ffffff",
          "iconBg": "#d73a49",
          "iconBorder": "rgba(0,0,0,0)"
        },
        "loading": {
          "text": "#24292e",
          "border": "#e1e4e8",
          "icon": "#ffffff",
          "iconBg": "#586069",
          "iconBorder": "rgba(0,0,0,0)"
        }
      },
      "timeline": {
        "text": "#444d56",
        "badgeBg": "#e1e4e8",
        "targetBadgeBorder": "#2188ff",
        "targetBadgeShadow": "#c8e1ff"
      },
      "selectMenu": {
        "borderSecondary": "#eaecef",
        "backdropBg": "rgba(27,31,35,0.5)",
        "backdropBorder": "rgba(0,0,0,0)",
        "tapHighlight": "rgba(209,213,218,0.5)",
        "tapFocusBg": "#dbedff"
      },
      "box": {
        "blueBorder": "#c8e1ff",
        "rowYellowBg": "#fffbdd",
        "rowBlueBg": "#f1f8ff",
        "headerBlueBg": "#f1f8ff",
        "headerBlueBorder": "#c8e1ff",
        "borderInfo": "rgba(3,102,214,0.2)",
        "bgInfo": "#f1f8ff",
        "borderWarning": "rgba(255,211,61,0.4)",
        "bgWarning": "#fffdef"
      },
      "branchName": {
        "text": "#586069",
        "icon": "#a8bbd0",
        "bg": "#eaf5ff",
        "link": {
          "text": "#0366d6",
          "icon": "#a8bbd0",
          "bg": "#eaf5ff"
        }
      },
      "markdown": {
        "codeBg": "rgba(27,31,35,0.05)",
        "frameBorder": "#dfe2e5",
        "blockquoteBorder": "#dfe2e5",
        "tableBorder": "#dfe2e5",
        "tableTrBorder": "#c6cbd1"
      },
      "menu": {
        "headingText": "#24292e",
        "borderActive": "#f9826c",
        "bgActive": "rgba(0,0,0,0)"
      },
      "sidenav": {
        "selectedBg": "#ffffff",
        "borderActive": "#f9826c"
      },
      "header": {
        "text": "rgba(255,255,255,0.7)",
        "bg": "#24292e",
        "logo": "#ffffff"
      },
      "filterItem": {
        "barBg": "#eff3f6"
      },
      "hiddenTextExpander": {
        "bg": "#dfe2e5",
        "bgHover": "#c6cbd1"
      },
      "dragAndDrop": {
        "border": "#c3c8cf"
      },
      "uploadEnabled": {
        "border": "#dfe2e5",
        "borderFocused": "#4a9eff"
      },
      "previewableCommentForm": {
        "border": "#c3c8cf"
      },
      "underlinenav": {
        "border": "rgba(209,213,218,0)",
        "borderHover": "#d1d5da",
        "borderActive": "#f9826c",
        "text": "#24292e",
        "textHover": "#24292e",
        "textActive": "#24292e",
        "icon": "#959da5",
        "iconHover": "#959da5",
        "iconActive": "#24292e",
        "counterText": "#24292e"
      },
      "verifiedBadge": {
        "text": "#22863a",
        "bg": "#ffffff",
        "border": "#e1e4e8"
      },
      "socialCount": {
        "bg": "#ffffff"
      },
      "tooltip": {
        "text": "#ffffff",
        "bg": "#24292e"
      },
      "headerSearch": {
        "bg": "#24292e",
        "border": "#444d56"
      },
      "searchKeyword": {
        "hl": "#fffbdd"
      },
      "diffstat": {
        "neutralBg": "#d1d5da",
        "neutralBorder": "#d1d5da",
        "deletionBg": "#d73a49",
        "deletionBorder": "#d73a49",
        "additionBg": "#28a745",
        "additionBorder": "#28a745"
      },
      "mktg": {
        "success": "#2ebc4f",
        "info": "#1074e7",
        "bgShadeGradient": {
          "top": "rgba(27,31,35,0.065)",
          "bottom": "rgba(27,31,35,0)"
        },
        "btn": {
          "bg": "#3076df",
          "border": "#3076df",
          "text": "#ffffff",
          "icon": "#ffffff",
          "hover": {
            "bg": "#0366d6",
            "border": "#0366d6"
          },
          "disabled": {
            "bg": "rgba(48,118,223,0.5)",
            "border": "rgba(0,0,0,0)",
            "text": "#ffffff",
            "icon": "#ffffff"
          },
          "primary": {
            "bg": "#5eb85c",
            "border": "#5eb85c",
            "text": "#ffffff",
            "icon": "#ffffff",
            "hover": {
              "bg": "#28a745",
              "border": "#28a745"
            },
            "disabled": {
              "bg": "rgba(94,184,92,0.5)",
              "border": "rgba(0,0,0,0)",
              "text": "#ffffff",
              "icon": "#ffffff"
            }
          },
          "outline": {
            "bg": "rgba(0,0,0,0)",
            "border": "rgba(42,103,195,0.5)",
            "text": "#3076df",
            "icon": "#3076df",
            "hover": {
              "bg": "rgba(0,0,0,0)",
              "border": "#0366d6",
              "text": "#0366d6",
              "icon": "#0366d6"
            },
            "disabled": {
              "bg": "rgba(0,0,0,0)",
              "border": "rgba(42,103,195,0.2)",
              "text": "rgba(48,118,223,0.5)",
              "icon": "rgba(48,118,223,0.5)"
            }
          },
          "dark": {
            "bg": "rgba(0,0,0,0)",
            "border": "rgba(255,255,255,0.5)",
            "text": "#ffffff",
            "icon": "#ffffff",
            "hover": {
              "bg": "#ffffff",
              "border": "#ffffff",
              "text": "#444d56",
              "icon": "#444d56"
            },
            "disabled": {
              "bg": "rgba(0,0,0,0)",
              "border": "rgba(255,255,255,0.2)",
              "text": "rgba(255,255,255,0.5)",
              "icon": "rgba(255,255,255,0.5)"
            }
          }
        }
      },
      "filesExplorerIcon": "#79b8ff",
      "hlAuthorBg": "#f1f8ff",
      "hlAuthorBorder": "#c8e1ff",
      "logoSubdued": "#d1d5da",
      "discussionBorder": "#a2cbac",
      "discussionBgSuccess": "#28a745",
      "actionsWorkflowTableStickyBg": "rgba(255,255,255,0.95)",
      "repoLanguageColorBorder": "rgba(27,31,35,0.1)",
      "codeSelectionBg": "#c8e1ff",
      "blob": {
        "lineHighlightBg": "#fffbdd",
        "lineHighlightBorder": "rgba(0,0,0,0)"
      },
      "diff": {
        "addition": {
          "text": "#22863a",
          "bg": "#e6ffed",
          "border": "#34d058"
        },
        "deletion": {
          "text": "#cb2431",
          "bg": "#ffeef0",
          "border": "#d73a49"
        },
        "change": {
          "text": "#b08800",
          "bg": "#fff5b1",
          "border": "#f9c513"
        }
      },
      "diffBlob": {
        "numText": "rgba(27,31,35,0.3)",
        "numHoverText": "rgba(27,31,35,0.6)",
        "addition": {
          "numText": "rgba(27,31,35,0.3)",
          "numHoverText": "rgba(27,31,35,0.6)",
          "numBg": "#cdffd8",
          "lineBg": "#e6ffed",
          "wordBg": "#acf2bd"
        },
        "deletion": {
          "numText": "rgba(27,31,35,0.3)",
          "numHoverText": "rgba(27,31,35,0.6)",
          "numBg": "#ffdce0",
          "lineBg": "#ffeef0",
          "wordBg": "#fdb8c0"
        },
        "hunk": {
          "text": "rgba(27,31,35,0.7)",
          "numBg": "#dbedff",
          "lineBg": "#f1f8ff"
        },
        "emptyBlockBg": "#fafbfc",
        "selectedLineHighlightBg": "rgba(255,223,93,0.2)",
        "selectedLineHighlightBorder": "#ffd33d",
        "expander": {
          "icon": "#586069",
          "hoverIcon": "#ffffff",
          "hoverBg": "#0366d6"
        },
        "commentButton": {
          "icon": "#ffffff",
          "bg": "#0366d6",
          "gradientBg": "#0372ef"
        }
      },
      "globalNav": {
        "logo": "#ffffff",
        "bg": "#24292e",
        "text": "#ffffff",
        "icon": "#ffffff",
        "inputBg": "#fafbfc",
        "inputBorder": "#fafbfc",
        "inputIcon": "#d1d5da",
        "inputPlaceholder": "#959da5"
      },
      "calendarGraph": {
        "dayBg": "#ebedf0",
        "dayBorder": "rgba(27,31,35,0.06)",
        "dayL1Bg": "#9be9a8",
        "dayL2Bg": "#40c463",
        "dayL3Bg": "#30a14e",
        "dayL4Bg": "#216e39",
        "dayL4Border": "rgba(27,31,35,0.06)",
        "dayL3Border": "rgba(27,31,35,0.06)",
        "dayL2Border": "rgba(27,31,35,0.06)",
        "dayL1Border": "rgba(27,31,35,0.06)"
      },
      "footerInvertocat": {
        "octicon": "#d1d5da",
        "octiconHover": "#6a737d"
      },
      "prState": {
        "draft": {
          "text": "#ffffff",
          "bg": "#6a737d",
          "border": "rgba(0,0,0,0)"
        },
        "open": {
          "text": "#ffffff",
          "bg": "#28a745",
          "border": "rgba(0,0,0,0)"
        },
        "merged": {
          "text": "#ffffff",
          "bg": "#6f42c1",
          "border": "rgba(0,0,0,0)"
        },
        "closed": {
          "text": "#ffffff",
          "bg": "#d73a49",
          "border": "rgba(0,0,0,0)"
        }
      },
      "topicTag": {
        "text": "#0366d6",
        "bg": "#f1f8ff",
        "hoverBg": "#ddeeff",
        "activeBg": "#e7f3ff"
      },
      "mergeBox": {
        "successIconBg": "#28a745",
        "successIconText": "#ffffff",
        "successIconBorder": "rgba(0,0,0,0)",
        "successIndicatorBg": "#28a745",
        "successIndicatorBorder": "rgba(0,0,0,0)",
        "mergedIconBg": "#6f42c1",
        "mergedIconText": "#ffffff",
        "mergedIconBorder": "rgba(0,0,0,0)",
        "mergedBoxBorder": "#6f42c1",
        "neutralIconBg": "#6a737d",
        "neutralIconText": "#ffffff",
        "neutralIconBorder": "rgba(0,0,0,0)",
        "neutralIndicatorBg": "#6a737d",
        "neutralIndicatorBorder": "rgba(0,0,0,0)",
        "warningIconBg": "#dbab09",
        "warningIconText": "#ffffff",
        "warningIconBorder": "rgba(0,0,0,0)",
        "warningBoxBorder": "#ffd33d",
        "warningMergeHighlight": "rgba(0,0,0,0)",
        "errorIconBg": "#d73a49",
        "errorIconText": "#ffffff",
        "errorIconBorder": "rgba(0,0,0,0)",
        "errorIndicatorBg": "#d73a49",
        "errorIndicatorBorder": "rgba(0,0,0,0)"
      },
      "project": {
        "cardBg": "#ffffff",
        "headerBg": "#24292e",
        "sidebarBg": "#ffffff",
        "gradientIn": "#ffffff",
        "gradientOut": "rgba(255,255,255,0)"
      },
      "introShelf": {
        "gradientLeft": "#f1f8ff",
        "gradientRight": "#dcffe4",
        "gradientIn": "#ffffff",
        "gradientOut": "rgba(255,255,255,0)"
      },
      "marketingIcon": {
        "primary": "#2188ff",
        "secondary": "#79b8ff"
      },
      "prettylights": {
        "syntax": {
          "comment": "#6a737d",
          "constant": "#005cc5",
          "entity": "#6f42c1",
          "storageModifierImport": "#24292e",
          "entityTag": "#22863a",
          "keyword": "#d73a49",
          "string": "#032f62",
          "variable": "#e36209",
          "brackethighlighterUnmatched": "#b31d28",
          "invalidIllegalText": "#fafbfc",
          "invalidIllegalBg": "#b31d28",
          "carriageReturnText": "#fafbfc",
          "carriageReturnBg": "#d73a49",
          "stringRegexp": "#22863a",
          "markupList": "#735c0f",
          "markupHeading": "#005cc5",
          "markupItalic": "#24292e",
          "markupBold": "#24292e",
          "markupDeletedText": "#b31d28",
          "markupDeletedBg": "#ffeef0",
          "markupInsertedText": "#22863a",
          "markupInsertedBg": "#f0fff4",
          "markupChangedText": "#e36209",
          "markupChangedBg": "#ffebda",
          "markupIgnoredText": "#f6f8fa",
          "markupIgnoredBg": "#005cc5",
          "metaDiffRange": "#6f42c1",
          "brackethighlighterAngle": "#586069",
          "sublimelinterGutterMark": "#959da5",
          "constantOtherReferenceLink": "#032f62"
        }
      },
      "codemirror": {
        "text": "#24292e",
        "bg": "#ffffff",
        "guttersBg": "#ffffff",
        "guttermarkerText": "#ffffff",
        "guttermarkerSubtleText": "#d1d5da",
        "linenumberText": "#959da5",
        "cursor": "#24292e",
        "selectionBg": "#c8e1ff",
        "activelineBg": "#fafbfc",
        "matchingbracketText": "#24292e",
        "linesBg": "#ffffff",
        "syntax": {
          "comment": "#6a737d",
          "constant": "#005cc5",
          "entity": "#6f42c1",
          "keyword": "#d73a49",
          "storage": "#d73a49",
          "string": "#032f62",
          "support": "#005cc5",
          "variable": "#e36209"
        }
      },
      "ansi": {
        "black": "#24292e",
        "blackBright": "#2f363d",
        "white": "#e1e4e8",
        "whiteBright": "#e1e4e8",
        "gray": "#959da5",
        "red": "#f97583",
        "redBright": "#fdaeb7",
        "green": "#85e89d",
        "greenBright": "#bef5cb",
        "yellow": "#ffea7f",
        "yellowBright": "#fff5b1",
        "blue": "#79b8ff",
        "blueBright": "#c8e1ff",
        "magenta": "#b392f0",
        "magentaBright": "#d1bcf9",
        "cyan": "#76e3ea",
        "cyanBright": "#b3f0ff"
      }
    },
    "fonts": {
      "normal": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"",
      "mono": "SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier, monospace"
    },
    "fontSizes": ["12px", "14px", "16px", "20px", "24px", "32px", "40px", "48px"],
    "fontWeights": {
      "light": 300,
      "normal": 400,
      "semibold": 500,
      "bold": 600
    },
    "lineHeights": {
      "condensedUltra": "1",
      "condensed": "1.25",
      "default": "1.5"
    },
    "radii": ["0", "3px", "6px", "100px"],
    "shadows": {
      "small": "0 1px 0 rgba(149, 157, 165, 0.1)",
      "medium": "0 3px 6px rgba(149, 157, 165, 0.15)",
      "large": "0 8px 24px rgba(149, 157, 165, 0.2)",
      "extra-large": "0 12px 48px rgba(149, 157, 165, 0.3)",
      "formControl": "inset 0px 2px 0px rgba(225, 228, 232, 0.2)",
      "formControlDisabled": "inset 0px 2px 0px rgba(220, 227, 237, 0.3)",
      "formControlFocus": "rgba(3, 102, 214, 0.3) 0px 0px 0px 0.2em",
      "primaryShadow": "0px 1px 0px rgba(20, 70, 32, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.03)",
      "primaryActiveShadow": "inset 0px 1px 0px rgba(20, 70, 32, 0.2)",
      "shadow": {
        "small": "0 1px 0 rgba(27,31,35,0.04)",
        "medium": "0 3px 6px rgba(149,157,165,0.15)",
        "large": "0 8px 24px rgba(149,157,165,0.2)",
        "extraLarge": "0 12px 48px rgba(149,157,165,0.3)",
        "highlight": "inset 0 1px 0 rgba(255,255,255,0.25)",
        "inset": "inset 0 1px 0 rgba(225,228,232,0.2)"
      },
      "state": {
        "focus": {
          "shadow": "0 0 0 3px rgba(3,102,214,0.3)"
        }
      },
      "autocomplete": {
        "shadow": "0 3px 6px rgba(149,157,165,0.15)"
      },
      "btn": {
        "shadow": "0 1px 0 rgba(27,31,35,0.04)",
        "insetShadow": "inset 0 1px 0 rgba(255,255,255,0.25)",
        "focusShadow": "0 0 0 3px rgba(3,102,214,0.3)",
        "shadowActive": "inset 0 0.15em 0.3em rgba(27,31,35,0.15)",
        "shadowInputFocus": "0 0 0 0.2em rgba(3,102,214,0.3)",
        "primary": {
          "shadow": "0 1px 0 rgba(27,31,35,0.1)",
          "insetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
          "selectedShadow": "inset 0 1px 0 rgba(20,70,32,0.2)",
          "focusShadow": "0 0 0 3px rgba(46,164,79,0.4)"
        },
        "outline": {
          "hoverShadow": "0 1px 0 rgba(27,31,35,0.1)",
          "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
          "selectedShadow": "inset 0 1px 0 rgba(5,38,76,0.2)",
          "focusShadow": "0 0 0 3px rgba(0,92,197,0.4)"
        },
        "danger": {
          "hoverShadow": "0 1px 0 rgba(27,31,35,0.1)",
          "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
          "selectedShadow": "inset 0 1px 0 rgba(134,24,29,0.2)",
          "focusShadow": "0 0 0 3px rgba(203,36,49,0.4)"
        }
      },
      "dropdown": {
        "shadow": "0 8px 24px rgba(149,157,165,0.2)"
      },
      "input": {
        "shadow": "inset 0 1px 2px rgba(27,31,35,0.075)"
      },
      "avatar": {
        "childShadow": "-2px -2px 0 rgba(255,255,255,0.8)"
      },
      "toast": {
        "shadow": "0 8px 24px rgba(149,157,165,0.2)"
      },
      "selectMenu": {
        "shadow": "0 0 18px rgba(27,31,35,0.4)"
      },
      "mktg": {
        "btn": {
          "focusShadow": "0 0 0 3px rgba(48,118,223,0.3)",
          "primary": {
            "focusShadow": "0 0 0 3px rgba(94,184,92,0.3)"
          },
          "outline": {
            "focusShadow": "0 0 0 3px rgba(42,103,195,0.3)"
          },
          "dark": {
            "focusShadow": "0 0 0 3px rgba(255,255,255,0.3)"
          }
        }
      }
    },
    "sizes": {
      "small": "544px",
      "medium": "768px",
      "large": "1012px",
      "xlarge": "1280px"
    },
    "space": ["0", "4px", "8px", "16px", "24px", "32px", "40px", "48px", "64px", "80px", "96px", "112px", "128px"],
    "buttons": {
      "default": {
        "color": {
          "default": "#24292e",
          "disabled": "#959da5"
        },
        "border": {
          "default": "rgba(27, 31, 35, 0.12)",
          "active": "#d1d5da",
          "disabled": "#eaecef"
        },
        "bg": {
          "default": "#fafbfc",
          "hover": "#F3F4F6",
          "active": "#edeff2",
          "disabled": "#fafbfc"
        },
        "shadow": {
          "default": "0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25)",
          "hover": "0px 1px 0px rgba(209, 213, 218, 0.2), inset 0px 2px 0px rgba(255, 255, 255, 0.1)",
          "active": "inset 0px 2px 0px rgba(149, 157, 165, 0.1)",
          "focus": "0 0 0 3px rgba(3, 102, 214, 0.3)"
        }
      },
      "primary": {
        "color": {
          "default": "#ffffff",
          "disabled": "rgba(255, 255, 255, 0.50)"
        },
        "border": {
          "default": "#22863a",
          "hover": "rgba(27, 31, 35, 0.15)",
          "active": "rgba(27, 31, 35, 0.15)",
          "disabled": "rgba(34, 134, 58, 0.1)"
        },
        "bg": {
          "default": "#2EA44F",
          "focus": "#2C974B",
          "hover": "#2C974B",
          "active": "#128031",
          "disabled": "#94D3A2"
        },
        "shadow": {
          "default": " 0px 1px 0px rgba(20, 70, 32, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.03)",
          "active": "0px 1px 0px rgba(27, 31, 35, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.03)",
          "hover": "0px 1px 0px rgba(27, 31, 35, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.03)",
          "focus": "0 0 0 3px #94D3A2"
        }
      },
      "danger": {
        "color": {
          "default": "#cb2431",
          "hover": "#ffffff",
          "active": "#ffffff",
          "disabled": "rgba(203,36,49, .5)"
        },
        "border": {
          "default": "#e1e4e8",
          "hover": "rgba(27, 31, 35, 0.15)",
          "active": "rgba(27, 31, 35, 0.15)"
        },
        "bg": {
          "default": "#fafbfc",
          "hover": "#cb2431",
          "active": "#be222e",
          "disabled": "#F3F4F6"
        },
        "shadow": {
          "default": "0px 1px 0px rgba(149, 157, 165, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.25)",
          "active": "0px 1px 0px rgba(27, 31, 35, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.03)",
          "hover": "0px 1px 0px rgba(27, 31, 35, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.03)",
          "focus": "0 0 0 3px rgba(203, 36, 49, 0.4)"
        }
      },
      "outline": {
        "color": {
          "default": "#0366d6",
          "hover": "#ffffff",
          "active": "#ffffff",
          "disabled": "#959da5"
        },
        "border": {
          "default": "#e1e4e8",
          "hover": "rgba(27, 31, 35, 0.15)",
          "active": "rgba(27, 31, 35, 0.15)"
        },
        "bg": {
          "default": "#fafbfc",
          "hover": "#0366d6",
          "active": "#035fc7",
          "disabled": "#F3F4F6"
        },
        "shadow": {
          "default": "0px 1px 0px rgba(149, 157, 165, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.25)",
          "active": "0px 1px 0px rgba(27, 31, 35, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.03)",
          "hover": "0px 1px 0px rgba(27, 31, 35, 0.1), inset 0px 2px 0px rgba(255, 255, 255, 0.03)",
          "focus": "0 0 0 3px rgba(3, 102, 214, 0.3)"
        }
      },
      "close": {
        "color": {
          "default": "#24292e"
        },
        "shadow": {
          "focus": "0 0 0 3px rgba(3, 102, 214, 0.3)"
        }
      }
    },
    "pagination": {
      "borderRadius": "6px",
      "spaceBetween": "4px",
      "colors": {
        "normal": {
          "fg": "#24292e"
        },
        "disabled": {
          "fg": "#d1d5da",
          "border": "transparent"
        },
        "hover": {
          "border": "#eaecef"
        },
        "selected": {
          "fg": "#ffffff",
          "bg": "#0366d6",
          "border": "transparent"
        },
        "active": {
          "border": "#eaecef"
        },
        "nextPrevious": {
          "fg": "#0366d6"
        }
      }
    },
    "popovers": {
      "colors": {
        "caret": "rgba(27, 31, 35, 0.15)"
      }
    },
    "flash": {
      "default": {
        "backgroundColor": "#dbedff",
        "borderColor": "rgba(4, 66, 137, 0.2)"
      },
      "success": {
        "backgroundColor": "#dcffe4",
        "borderColor": "rgba(23, 111, 44, 0.2)"
      },
      "danger": {
        "backgroundColor": "#FFE3E6",
        "borderColor": "rgba(158, 28, 35, 0.2)"
      },
      "warning": {
        "backgroundColor": "#fffbdd",
        "borderColor": "rgba(176, 136, 0, 0.2)"
      }
    },
    "flashIcon": {
      "default": "rgba(4, 66, 137, 0.6)",
      "success": "rgba(23, 111, 44, 0.8)",
      "danger": "rgba(158, 28, 35, 0.6)",
      "warning": "#b08800"
    },
    "stateLabels": {
      "sizes": {
        "small": {
          "padding": "4px 8px",
          "fontSize": "12px"
        },
        "normal": {
          "padding": "8px 12px",
          "fontSize": "14px"
        }
      },
      "status": {
        "issueClosed": {
          "backgroundColor": "#d73a49"
        },
        "pullClosed": {
          "backgroundColor": "#d73a49"
        },
        "pullMerged": {
          "backgroundColor": "#6f42c1"
        },
        "issueOpened": {
          "backgroundColor": "#159739"
        },
        "pullOpened": {
          "backgroundColor": "#159739"
        },
        "draft": {
          "backgroundColor": "#6a737d"
        }
      }
    }
  },
  "colors": {
    "bodytext": "#24292e",
    "black": "#1b1f23",
    "white": "#ffffff",
    "gray": ["#fafbfc", "#f6f8fa", "#e1e4e8", "#d1d5da", "#959da5", "#6a737d", "#586069", "#444d56", "#2f363d", "#24292e"],
    "blue": ["#f1f8ff", "#dbedff", "#c8e1ff", "#79b8ff", "#2188ff", "#0366d6", "#005cc5", "#044289", "#032f62", "#05264c"],
    "green": ["#f0fff4", "#dcffe4", "#bef5cb", "#85e89d", "#34d058", "#28a745", "#22863a", "#176f2c", "#165c26", "#144620"],
    "orange": ["#fff8f2", "#ffebda", "#ffd1ac", "#ffab70", "#fb8532", "#f66a0a", "#e36209", "#d15704", "#c24e00", "#a04100"],
    "purple": ["#f5f0ff", "#e6dcfd", "#d1bcf9", "#b392f0", "#8a63d2", "#6f42c1", "#5a32a3", "#4c2889", "#3a1d6e", "#29134e"],
    "red": ["#ffeef0", "#ffdce0", "#fdaeb7", "#f97583", "#ea4a5a", "#d73a49", "#cb2431", "#b31d28", "#9e1c23", "#86181d"],
    "yellow": ["#fffdef", "#fffbdd", "#fff5b1", "#ffea7f", "#ffdf5d", "#ffd33d", "#f9c513", "#dbab09", "#b08800", "#735c0f"],
    "pink": ["#ffeef8", "#fedbf0", "#f9b3dd", "#f692ce", "#ec6cb9", "#ea4aaa", "#d03592", "#b93a86", "#99306f", "#6d224f"],
    "blackfade15": "rgba(27, 31, 35, 0.15)",
    "blackfade20": "rgba(27, 31, 35, 0.20)",
    "blackfade30": "rgba(27,31,35,0.3)",
    "blackfade35": "rgba(27, 31, 35, 0.35)",
    "blackfade50": "rgba(27, 31, 35, 0.5)",
    "whitefade15": "rgba(255, 255, 255, 0.15)",
    "whitefade50": "rgba(255, 255, 255, 0.50)",
    "whitefade70": "rgba(255, 255, 255, 0.70)",
    "state": {
      "error": "#d73a49",
      "failure": "#d73a49",
      "pending": "#dbab09",
      "queued": "#dbab09",
      "success": "#28a745",
      "unknown": "#959da5"
    },
    "border": {
      "blackFade": "rgba(27,31,35,0.15)",
      "blue": "#0366d6",
      "blueLight": "#c8e1ff",
      "grayLight": "#eaecef",
      "gray": "#e1e4e8",
      "grayDark": "#d1d5da",
      "grayDarker": "#444d56",
      "green": "#34d058",
      "greenLight": "#a2cbac",
      "purple": "#6f42c1",
      "red": "#d73a49",
      "redLight": "#cea0a5",
      "white": "#ffffff",
      "whiteFade": "rgba(255,255,255,0.15)",
      "yellow": "#d9d0a5"
    },
    "counter": {
      "bg": "rgba(27, 31, 35, 0.08)"
    },
    "filterList": {
      "hoverBg": "#eaecef"
    },
    "text": {
      "white": "#ffffff",
      "gray": "#586069",
      "grayLight": "#6a737d",
      "grayDark": "#24292e",
      "red": "#cb2431"
    },
    "bg": {
      "gray": "#f6f8fa",
      "grayLight": "#fafbfc",
      "grayDark": "#24292e",
      "disabled": "#F3F4F6"
    },
    "accent": "#f66a0a",
    "labels": {
      "gray": "#e1e4e8",
      "grayText": "#24292e",
      "grayDark": "#6a737d",
      "grayDarkText": "#24292e",
      "blue": "#0366d6",
      "blueText": "#0366d6",
      "orange": "#f66a0a",
      "orangeText": "#e36209",
      "green": "#28a745",
      "greenText": "#22863a",
      "red": "#cb2431",
      "redText": "#cb2431",
      "yellow": "#f9c513",
      "yellowText": "#735c0f",
      "pink": "#ec6cb9",
      "pinkText": "#d03592",
      "purple": "#8a63d2",
      "purpleText": "#6f42c1"
    }
  }
};